<template>
  <li class="c-menu__item" :id="id" :class="{'c-menu__item--childless': !hasChildren}">

      <a
        :href="linkUrl"
        class="c-menu__link"
        :class="linkingMode"
      >
        {{ title }}

      </a>
      <div 
        v-if="hasChildren"
        v-on:click="toggleOpen"
        class="c-menu__link-chevron-wrapper"
        :class="{'c-menu__link-chevron-wrapper--open': open}"
      >
        <span class="c-menu__link-chevron"></span>
      </div>

    <div v-show="open">
      <slot name="child-menu-item"></slot>
    </div>
  </li>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    title: String,
    linkUrl: String,
    hasChildren: Boolean,
    childMenuOpenId: Number,
    linkingMode: String,
  },
  mounted() {
    this.id = this._uid;
    if (this.linkingMode == 'current') {
      this.open = true;
    }
  },
  data() {
    return {
      id: null,
      open: false,
    };
  },
  watch: {
    childMenuOpenId(newVal) {
      if (newVal == this.id) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
  },
  methods: {
    toggleOpen: function () {
      this.open = !this.open;
      this.$emit("child-menu-toggle", this.id);
    },
  },
};
</script>
